export * from './people-employee.dto';
export * from './people-employee-bank-details.dto';
export * from './people-employee-clock-in-out.dto';
export * from './people-employee-contract.dto';
export * from './people-employee-file.dto';
export * from './people-employee-leave.dto';
export * from './people-employee-next-of-kin.dto';
export * from './people-employee-personal-details.dto';
export * from './people-employee-visa.dto';
export * from './people-employee-work-profile.dto';